import { useDispatch } from 'react-redux';

import { STEP_SLUG } from '../../constants';
import { StyledButton, StyledClickable } from '../step-footer-navigation/styles';
import { useByocNavigationContext } from '../../context/byoc-navigation-context';
import BuildYourCoverActions from '../../../../actions/build-your-cover';
import type { BuildYourCoverProductType } from '../../../../actions/build-your-cover';

const SLUG_TO_PRODUCT_TYPE: Partial<Record<string, BuildYourCoverProductType>> = {
  [STEP_SLUG.EXTRAS]: 'extras',
  [STEP_SLUG.HOSPITAL]: 'hospital',
};

type Props = {
  onNextClick?: Function;
};

const ForwardButtons = ({ onNextClick }: Props) => {
  const { activeSlug, analyticsLabel, goToNextStep, isLastStep, isServicesStep } = useByocNavigationContext();
  const dispatch = useDispatch();

  const handleSkipClick = () => {
    const productType = SLUG_TO_PRODUCT_TYPE[activeSlug];
    if (productType) {
      BuildYourCoverActions.skipStep(productType)(dispatch);
    }
    goToNextStep();
  };

  const handleOnNextClick = () => {
    if (onNextClick) {
      onNextClick();
    } else {
      goToNextStep();
    }
  };

  if (!isServicesStep && isLastStep) {
    return null;
  }

  return (
    <>
      {isServicesStep && (
        <StyledClickable analytics={{ label: `Skip - ${analyticsLabel}` }} onClick={handleSkipClick}>
          Skip
        </StyledClickable>
      )}
      {!isLastStep && (
        <StyledButton analytics={{ label: `Next - ${analyticsLabel}` }} onClick={handleOnNextClick}>
          Next
        </StyledButton>
      )}
    </>
  );
};

export default ForwardButtons;
